import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { ArrowRight, Calendar, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
const formationsData = [{
  id: 1,
  format: "OCT 2026",
  category: "Europe",
  title: "La Démence 37th Anniversary",
  date: "Oct 30 - Nov 1, 2026",
  duration: "Brussels, Belgium",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/la_demence_brussels.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/la_demence_brussels.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/la_demence_brussels.png-wvc-sizes",
  link: "/GlobalCircuitQueerPartyExperiencesPage"
}, {
  id: 2,
  format: "NOV 2026",
  category: "North America",
  title: "Atlantis Thanksgiving Caribbean Cruise",
  date: "Nov 22 - 29, 2026",
  duration: "Miami/Caribbean",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/atlantis_gay_cruise_caribbean.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/atlantis_gay_cruise_caribbean.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/atlantis_gay_cruise_caribbean.png-wvc-sizes",
  link: "/BespokeCruisesPage"
}, {
  id: 3,
  format: "NOV 2026",
  category: "Latin America",
  title: "Industry Thanksgiving Festival 2026",
  date: "Nov 26 - 29, 2026",
  duration: "Puerto Vallarta, Mexico",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/elegant-minimalist-luxury-travel-photogr-ecbf87.png",
  link: "/GlobalCircuitQueerPartyExperiencesPage",
  imageAlt: "AI-generated image of a tropical Mexican coastline at sunset with a beachfront villa, palm trees and mountains, representing the Puerto Vallarta destination"
}, {
  id: 4,
  format: "DEC 2026",
  category: "Asia",
  title: "Tomorrowland Thailand 2026",
  date: "Dec 11 - 13, 2026",
  duration: "Bangkok, Thailand",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/hero_tomorrowland_thailand.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/hero_tomorrowland_thailand.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/hero_tomorrowland_thailand.png-wvc-sizes",
  link: "/RaveEdmPage"
}, {
  id: 5,
  format: "DEC 2026 / JAN 2027",
  category: "Asia",
  title: "White Party Bangkok 2026–2027",
  date: "Dec 29, 2026 - Jan 3, 2027",
  duration: "Bangkok, Thailand",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/elegant-minimalist-luxury-travel-photogr-071963.png",
  link: "/GlobalCircuitQueerPartyExperiencesPage",
  imageAlt: "AI-generated twilight aerial view of Wat Arun and the Chao Phraya River with the Bangkok skyline, representing the Bangkok destination"
}];
export default function GlobalEventCalendar() {
  return <section data-section-id="258166" id="global-event-calendar" className="bg-background text-foreground py-16 px-6 md:px-8">
      <div className="max-w-7xl mx-auto">
        <Carousel opts={{
        align: "start",
        loop: false
      }} className="w-full">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
            <div className="flex items-center gap-4">
              <h2 className="text-foreground font-default text-2xl md:text-3xl font-light tracking-tight">
                Global Event Calendar
              </h2>
              <Link to="/ExperiencesPage" className="hidden sm:flex items-center gap-1 text-muted-foreground hover:text-primary font-default text-xs uppercase tracking-widest transition-colors">
                View All
                <ArrowRight className="size-4" />
              </Link>
            </div>
            <div className="flex items-center gap-2 self-end sm:self-auto">
              <CarouselPrevious className="static translate-y-0 translate-x-0 left-auto right-auto top-auto bottom-auto bg-background border-border hover:bg-secondary hover:text-secondary-foreground rounded-md" />
              <CarouselNext className="static translate-y-0 translate-x-0 left-auto right-auto top-auto bottom-auto bg-background border-border hover:bg-secondary hover:text-secondary-foreground rounded-md" />
            </div>
          </div>

          <CarouselContent className="-ml-4 md:-ml-6">
            {formationsData.map((formation, index) => <CarouselItem key={formation.id} data-index={index} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3 xl:basis-1/4">
                <Card className="h-full flex flex-col overflow-hidden border-border shadow-sm hover:shadow-lg transition-all duration-500 rounded-md group">
                  <div className="relative w-full">
                    <AspectRatio ratio={3 / 4}>
                      <img src={formation.imageSrc} {...formation.imageSrcset ? {
                    "data-wvc-srcset": formation.imageSrcset
                  } : {}} {...formation.imageSizes ? {
                    "data-wvc-sizes": formation.imageSizes
                  } : {}} alt={formation.imageAlt ?? formation.title} className="object-cover w-full h-full grayscale hover:grayscale-0 transition-all duration-700" loading="lazy" />
                    </AspectRatio>
                    <Badge variant="default" className="absolute top-4 left-4 max-w-[calc(100%-2rem)] whitespace-normal bg-background/80 backdrop-blur-sm text-foreground font-default text-[10px] tracking-widest uppercase rounded-md border-none">
                      {formation.format}
                    </Badge>
                    <div className="absolute inset-0 bg-foreground/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                       <Link to={formation.link} className="bg-background text-foreground px-6 py-2 font-default text-xs uppercase tracking-widest rounded-md shadow-md">
                          Inquire
                       </Link>
                    </div>
                  </div>
                  <CardContent className="p-6 flex flex-col flex-grow gap-2 bg-background">
                    <span className="text-muted-foreground text-[10px] font-default uppercase tracking-widest">
                      {formation.category}
                    </span>
                    <h3 className="text-foreground font-serif text-xl font-medium leading-tight line-clamp-2 flex-grow">
                      {formation.title}
                    </h3>
                    <div className="flex flex-col gap-1 text-muted-foreground font-default text-xs mt-2 pt-4 border-t border-border/30">
                      <div className="flex items-start gap-2">
                        <SafeHydrate><Calendar className="size-3 opacity-60 shrink-0 mt-0.5" /></SafeHydrate>
                        <span className="break-words">{formation.date}</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <Clock className="size-3 opacity-60 shrink-0 mt-0.5" />
                        <span className="break-words">{formation.duration}</span>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="mt-8 sm:hidden flex justify-center">
             <Link to="/ExperiencesPage" className="flex items-center gap-2 text-muted-foreground hover:text-primary font-default text-xs uppercase tracking-widest transition-colors">
                Explore All Events
                <ArrowRight className="size-4" />
              </Link>
          </div>
        </Carousel>
      </div>
    </section>;
}